import { createStore, applyMiddleware, compose } from "redux";
import appReducer from "../reducers";
import thunk from "redux-thunk";

// console.debug('store: ',process.env.REACT_APP_ENV)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
    if (process.env.REACT_APP_ENV !== 'dev') {
        return createStore(
            appReducer,
            {},
            applyMiddleware(
                thunk
            )
        );
    }
    return createStore(
        appReducer,
        {},
        composeEnhancers(
            applyMiddleware(
                thunk
            )
        )
    );
}